"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildReadOnlyTwoWayIndexMapForEnum = exports.ReadOnlyTwoWayMap = void 0;
class ReadOnlyTwoWayMap {
    constructor(map) {
        this.getForward = (key) => {
            return this.forwardMap.get(key);
        };
        this.getBackward = (value) => {
            return this.backwardMap.get(value);
        };
        this.getSize = () => this.forwardMap.size;
        this.items = () => {
            return this.forwardMap.entries();
        };
        this.forwardMap = map;
        this.backwardMap = new Map();
        for (const [key, value] of map) {
            this.backwardMap.set(value, key);
        }
    }
}
exports.ReadOnlyTwoWayMap = ReadOnlyTwoWayMap;
const buildReadOnlyTwoWayIndexMapForEnum = (anEnum) => {
    const oneWayMap = new Map();
    let currentIndex = 0;
    for (const enumValue of Object.values(anEnum)) {
        oneWayMap.set(enumValue, currentIndex);
        currentIndex++;
    }
    return new ReadOnlyTwoWayMap(oneWayMap);
};
exports.buildReadOnlyTwoWayIndexMapForEnum = buildReadOnlyTwoWayIndexMapForEnum;
//# sourceMappingURL=twoWayMap.js.map